import ajax from "@/lib/ajax";

// 查询转床患者列表
export async function QueryPDChangeBedList(payload: any) {
    let res = await ajax.post(`/api/services/app/PDChangeBed/QueryPDChangeBedList`, payload);
    return res.data.result;
}


// WEBPACK FOOTER //
// ./src/api/pdTransferAndChangeBed/pdChangeBed/index.ts